import { BehaviorSubject, catchError, filter, finalize, Observable, of, skip, Subject, switchMap, takeUntil, tap } from "rxjs";
import { FilterResponse } from "../../../src/05_components/filter/dto/filter.dto";
import { ISearchModel, ISearchRequest } from "../../../src/05_components/search/dto/requestBody.dto";
import { IFilterSearchResponse } from "../../../src/05_components/filter/dto/filterSearch.dto";


export class SearchRequestService {
  private cancelRequests: Subject<boolean> = new Subject();

  constructor(private serachElement: HTMLElement, private searchRequest: BehaviorSubject<ISearchRequest>, private searchResponse: BehaviorSubject<ISearchModel>, private loading: Subject<boolean>, private error: Subject<Error>) {
    this.searchRequest.pipe(
      skip(1),
      tap(() => {
        this.loading.next(true);
        this.error.next(null);
        this.cancelRequests.next(true);
      }),
      switchMap(request =>
        this.fetchResponse(request).pipe(
          takeUntil(this.cancelRequests.pipe(filter(Boolean))),
          catchError((error) => {
            this.error.next(error);
            return of(({}) as ISearchModel);
          }),
          finalize(() => this.loading.next(false))
        )
      )
    ).subscribe(request => {
      this.searchResponse.next(request);
    });
  }

  private fetchResponse(request: ISearchRequest): Observable<ISearchModel> {
    return new Observable<ISearchModel>((subscriber) => {
      const controller = new AbortController();
      const signal = controller.signal;

      fetch('/websitesearch/products', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(request),
        signal,
      })
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) throw new Error(`${res.status} ${data.statusMessage}`);
        subscriber.next(data.data);
        subscriber.complete();
      })
      .catch((err) => {
        if (err.name !== 'AbortError') {
          subscriber.error(err);
        }
      });

      return () => controller.abort();
    });
  }
}
